<div class="row text-center">
    <div class="col-md-4">
        <mat-button-toggle-group>
            <mat-button-toggle mwlCalendarPreviousView [view]="currentView"
                [(viewDate)]="viewDate" (viewDateChange)="viewDateChange.next(viewDate)">
                {{'CALENDER.PREVIOUS' | translate}}
            </mat-button-toggle>
            <mat-button-toggle mwlCalendarToday checked="true"
                [(viewDate)]="viewDate" (viewDateChange)="viewDateChange.next(viewDate)">
                {{'CALENDER.TODAY' | translate}}
            </mat-button-toggle>
            <mat-button-toggle mwlCalendarNextView [view]="currentView"
                [(viewDate)]="viewDate" (viewDateChange)="viewDateChange.next(viewDate)">
                {{'CALENDER.NEXT' | translate}}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <div class="col-md-4">
        <h3>{{ viewDate | calendarDate:('monthViewTitle'):'en' }}</h3>
    </div>
</div>
<ng-template #loading>
    <div class="text-center">
      <i class="fa fa-spin fa-spinner fa-5x"></i>
      <br>
      {{'CALENDER.LOADING_EVENTS' | translate}}
    </div>
</ng-template>

<div *ngIf="events">
    <mwl-calendar-month-view [viewDate]="viewDate" [events]="events" [activeDayIsOpen]="activeDayIsOpen"
        (dayClicked)="dayClicked($event.day)">
    </mwl-calendar-month-view>
</div>